export default __webpack_public_path__ + "static/media/08_photo.30c87e38.jpg";